export abstract class ChatMessage {
    date: Date;
    type: string;
    user: any;

    constructor() {
        this.date = new Date();
    }
}
